/**
 * @namespace Collapse
 * @aka SWRNEU.Collapse
 *
 */
SWRNEU.Collapse = (function ($) {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'collapse';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: '[data-toggle="collapse"]'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Collapse = function () {

    function Collapse(element, config) {
      COMMON.Utils._classCallCheck(this, Collapse);

      var self = this;

      //Der Button, der ein Target öffnen/schließen soll
      self.element = element;
      self.$element = $(self.element);
      self.isButton = true;

      //Das Target, das geöffnet/geschlossen werden soll
      if(self.element.tagName === "A") {
        self.isButton = false;
        self.target = self.element.hash;
      } else {
        self.target = self.$element.data('target');
      }

      self.$target = $(self.target);

      //Das Target hat ein parent-Attribut
      let parentSelector = self.$target.data('parent');

      if(parentSelector === undefined) {
        //Falls das Target keinen parent hat, muss geschaut werden,
        //ob der Button selbst einen parent hat
        parentSelector = self.$element.data('parent');
      }

      if(parentSelector === "#") {
        //In Fractal gibt es manchmal den Fall,
        //dass # als Parent definiert wurde. Damit
        //kann jQuery aber nichts anfangen, weil es kein
        //valider Selektor ist.
        self.$targetParent = null;
      } else {
        self.$targetParent = $(parentSelector);
      }

      //Es kann mehrere Buttons für ein Target geben
      self.$multipleButtons = $('[data-target="' + self.target + '"]');

      self.bindEvents();
    }

    Collapse.prototype.bindEvents = function bindEvents() {
      var self = this;

      self.$element.on('click', function (event) {
        if(!self.isButton) {
          event.preventDefault();
        }
        $(this).trigger('focus');
        self.checkElement();
      });

      self.$element.on('swr:collapse:show', function (event) {
        if(self.$element.is($(event.target))) {
          self.show();
        }
      });
      self.$target.on('swr:collapse:show', function (event) {
        if(self.$target.is($(event.target))) {
          self.show();
        }
      });
      self.$element.on('swr:collapse:hide', function (event) {
        if(self.$element.is($(event.target))) {
          self.hide();
        }
      });
      self.$target.on('swr:collapse:hide', function (event) {
        if(self.$target.is($(event.target))) {
          self.hide();
        }
      });


      //Damit alter Code weiter funktioniert:
      self.$element.on('bs.collapse.show', function () {
        self.show();
      });
      self.$target.on('bs.collapse.show', function (){
        self.show();
      });
      self.$element.on('bs.collapse.hide', function () {
        self.hide();
      });
      self.$target.on('bs.collapse.hide', function (){
        self.hide();
      });
    };

    Collapse.prototype.checkElement = function checkElement() {
      var self = this;

      if (self.$targetParent) {
        //Alle Geschwister werden geschlossen
        self.$targetParent.find('[data-toggle="collapse"]').each(function () {
          if(!self.$element.is($(this))) {
            $(this).trigger('swr:collapse:hide');
          }
        });
      }

      switch (self.$element.attr('aria-expanded')) {
        case 'false':
          self.show();
          break;
        case 'true':
          self.hide();
      }
    };

    Collapse.prototype.show = function show() {
      var self = this;
      self.$element.attr('aria-expanded', 'true');
      self.$multipleButtons.each(function () {
        $(this).trigger('swr:collapse:showing');
        $(this).attr('aria-expanded', 'true');
        $(this).removeClass('collapsed');
      });

      self.$target.removeClass('hidden');
      self.$target.addClass('collapsing showing');
      self.$target.trigger('swr:collapse:showing');
      self.$target.removeClass('collapse collapsed');
      self.$target.trigger('focus');

      window.setTimeout(function () {
        self.$target.addClass('collapse show');
        self.$target.removeClass('collapsing showing');

        self.$multipleButtons.each(function () {
          $(this).trigger('swr:collapse:shown');
        });
        self.$target.trigger('swr:collapse:shown');
      }, 300);
    };

    Collapse.prototype.hide = function hide() {
      var self = this;

      if(self.$element.attr('aria-expanded') === "true"){
        self.$element.attr('aria-expanded', 'false');
        self.$element.addClass('collapsed');
        self.$multipleButtons.each(function () {
          $(this).trigger('swr:collapse:hiding');
          $(this).attr('aria-expanded', 'false');
          $(this).addClass('collapsed');
        });

        self.$target.addClass('collapsing hiding');
        self.$target.trigger('swr:collapse:hiding');
        self.$target.removeClass('collapse show');

        window.setTimeout(function () {
          self.$target.addClass('collapse hidden');
          self.$target.removeClass('collapsing hiding');

          self.$multipleButtons.each(function () {
            $(this).trigger('swr:collapse:hidden');
          });
          self.$target.trigger('swr:collapse:hidden');
        }, 300);
      }
    };

    // public
    Collapse.prototype.dispose = function dispose() {
      this.$element.off(EVENT_KEY);

      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // static
    Collapse._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $element = $(this);

        // This plugin is trigger-centric. If called on a target, find the trigger and restart.
        if (!$element.is('[data-toggle="collapse"]')) {
            var targetId = '#' + $element.attr('id');
            var $trigger = $('[data-toggle="collapse"][data-target="' + targetId + '"], [data-toggle="collapse"][href="' + targetId + '"]').first();
            if ($trigger.length) {
                Collapse._jQueryInterface.call($trigger, config);
            }
            return; // Stop processing on the target
        }

        // From here on, we are on a trigger element.
        var data = $element.data(DATA_KEY);
        if (!data) {
          data = new Collapse(this); // 'this' is the trigger element
          $element.data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (config === 'toggle') {
            data.checkElement();
          } else if (typeof data[config] === 'function') {
            data[config]();
          }
        }
      });
    };

    return Collapse;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    Collapse._jQueryInterface.call($element, $element.data());
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      Collapse._jQueryInterface.call($element);
    });
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if(mutation.type === 'childList') {
        mutation.addedNodes.forEach(function (node){
          if(node.nodeType === Node.ELEMENT_NODE) {
            const $element = $(node);
            if($element.is('[data-toggle="collapse"]')) {
              Collapse._jQueryInterface.call($element);
            } else {
              $element.find('[data-toggle="collapse"]').each(function (){
                Collapse._jQueryInterface.call($(this));
              });
            }
          }
        })
      } else if(mutation.type === 'attributes') {
        if(mutation.attributeName === 'data-toggle') {
          const $element = $(mutation.target);
          if($element.attr('data-toggle') === 'collapse') {
            Collapse._jQueryInterface.call($element);
          }
        }
      }
    })
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Collapse._jQueryInterface;
  $.fn[NAME].Constructor = Collapse;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Collapse._jQueryInterface;
  };

  return Collapse;

})(window.jQuery);
